<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0041_master_system</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-search title="余剰ライセンス割当依頼一覧"></title-and-search>
          <search-control 
          style="padding-bottom: 10px;"
          :field_names="allFields" @change="searchControlChangedDatasource"></search-control>
          <ag-grid-vue style="width: 100%; height: 325px" class="ag-blue" :gridOptions="gridOptions" ></ag-grid-vue>
          <br>
          <div style="float: left;;margin-top:5px">
            件数
          </div>
          <input type="text" data-cy="totalNumberOfRows" style="width: 5%;text-align: right;float: left;margin-left:5px" class="form-control limited-height-box" :disabled="true" :value="totalNumberOfRows" />
          <div style="margin-top:5px;">

           <button
            :disabled="formExportFileDisabled || checkUserPermission(true,permissionMode.EXPORT) == false"
            class="btn btn-success" style="min-width:100px;float: right;margin-left: 10px;border-color: #7D2A2B;background: rgb(185 87 77);" @click="initExportFile">出力</button>

          <button class="btn btn-primary" style="min-width:100px;float:right;margin-left: 10px;" @click="backToList" >＜　戻る</button>

            <file-download-modal tag="runSurplusLicenseDownloadModal" @close="onCloseExportFile"/>
          </div>

        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_surplus_license';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:surplus_license_request');
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';
import fileDownloadModal from '@/components/modals/file-download-modal';
export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'ag-grid-vue': AgGridVue,
    'file-download-modal':fileDownloadModal
  },
  data() {
    return {
      api_name:"surplus_license_request",
      page_acl: acl.surplus_license,
      detail_page:"page_0020_surplus_license_detail_review",
      execute_filter_on_back:true,
      link_to_open:"#"
    };
  },
  computed: {
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields(){
      return this.tabFieldList;
    },
    values() {
      console.log('values');
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      return [
        utils.extend(fields.approval_status, {}),
        utils.extend(fields.jurisdiction_department, {}),
        utils.extend(fields.jurisdiction_team, {}),
        utils.extend(fields.software_name, {}),
        utils.extend(fields.desired_number, {}),
        utils.extend(fields.requester, {}),
      ];
    },
    linkToOpen:{
      get(){
        return this.link_to_open;
      },
      set(v){
        this.link_to_open = v;
      }
    },
  },
  methods: {
    backToList(){
      return this.$router.push({ name: "page_0020_surplus_license", params: {} });
    },
    initExportFile(){
    },
    onCloseExportFile(){},
    onDetailsClick(ev, data) {
      return this.$router.push({ name: this.detail_page, params: {  review_seq_id:data.seq_id , seq_id:data.surplus_license_seq_id} });
    },
    createColumnDefs() {
      return this.commonCreateColumnDefs({show_details:true,show_checkbox:false})
    },
    onRowSelected(ev){
      this.selected_row = ev.node.data.seq_id;
    }
  },
  mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy() {
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
    this.gridOptions = _.extend(this.commonGridOptions,{}) ;
    this.initDatasource();
  }
};

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// page_0020_surplus_license_request.vue?282973ac